/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_directions } from './maps/directions.icon';
import { icon_beenhere } from './maps/beenhere.icon';
import { icon_directions_bike } from './maps/directions_bike.icon';
import { icon_add_location } from './maps/add_location.icon';
import { icon_directions_boat } from './maps/directions_boat.icon';
import { icon_directions_railway } from './maps/directions_railway.icon';
import { icon_directions_car } from './maps/directions_car.icon';
import { icon_directions_bus } from './maps/directions_bus.icon';
import { icon_directions_run } from './maps/directions_run.icon';
import { icon_directions_subway } from './maps/directions_subway.icon';
import { icon_edit_location } from './maps/edit_location.icon';
import { icon_directions_transit } from './maps/directions_transit.icon';
import { icon_directions_walk } from './maps/directions_walk.icon';
import { icon_ev_station } from './maps/ev_station.icon';
import { icon_hotel } from './maps/hotel.icon';
import { icon_flight } from './maps/flight.icon';
import { icon_layers } from './maps/layers.icon';
import { icon_local_bar } from './maps/local_bar.icon';
import { icon_local_activity } from './maps/local_activity.icon';
import { icon_layers_clear } from './maps/layers_clear.icon';
import { icon_local_atm } from './maps/local_atm.icon';
import { icon_local_cafe } from './maps/local_cafe.icon';
import { icon_local_airport } from './maps/local_airport.icon';
import { icon_local_convenience_store } from './maps/local_convenience_store.icon';
import { icon_local_dining } from './maps/local_dining.icon';
import { icon_local_drink } from './maps/local_drink.icon';
import { icon_local_car_wash } from './maps/local_car_wash.icon';
import { icon_local_gas_station } from './maps/local_gas_station.icon';
import { icon_local_florist } from './maps/local_florist.icon';
import { icon_local_grocery_store } from './maps/local_grocery_store.icon';
import { icon_local_hotel } from './maps/local_hotel.icon';
import { icon_local_hospital } from './maps/local_hospital.icon';
import { icon_local_laundry_service } from './maps/local_laundry_service.icon';
import { icon_local_movies } from './maps/local_movies.icon';
import { icon_local_library } from './maps/local_library.icon';
import { icon_local_mall } from './maps/local_mall.icon';
import { icon_local_offer } from './maps/local_offer.icon';
import { icon_local_parking } from './maps/local_parking.icon';
import { icon_local_play } from './maps/local_play.icon';
import { icon_local_phone } from './maps/local_phone.icon';
import { icon_local_pharmacy } from './maps/local_pharmacy.icon';
import { icon_local_pizza } from './maps/local_pizza.icon';
import { icon_local_post_office } from './maps/local_post_office.icon';
import { icon_local_printshop } from './maps/local_printshop.icon';
import { icon_local_see } from './maps/local_see.icon';
import { icon_local_taxi } from './maps/local_taxi.icon';
import { icon_my_location } from './maps/my_location.icon';
import { icon_local_shipping } from './maps/local_shipping.icon';
import { icon_map } from './maps/map.icon';
import { icon_navigation } from './maps/navigation.icon';
import { icon_near_me } from './maps/near_me.icon';
import { icon_place } from './maps/place.icon';
import { icon_person_pin_circle } from './maps/person_pin_circle.icon';
import { icon_person_pin } from './maps/person_pin.icon';
import { icon_pin_drop } from './maps/pin_drop.icon';
import { icon_restaurant } from './maps/restaurant.icon';
import { icon_rate_review } from './maps/rate_review.icon';
import { icon_satellite } from './maps/satellite.icon';
import { icon_store_mall_directory } from './maps/store_mall_directory.icon';
import { icon_terrain } from './maps/terrain.icon';
import { icon_streetview } from './maps/streetview.icon';
import { icon_subway } from './maps/subway.icon';
import { icon_traffic } from './maps/traffic.icon';
import { icon_tram } from './maps/tram.icon';
import { icon_transfer_within_a_station } from './maps/transfer_within_a_station.icon';
import { icon_train } from './maps/train.icon';
import { icon_zoom_out_map } from './maps/zoom_out_map.icon';
import { icon_restaurant_menu } from './maps/restaurant_menu.icon';
var icons = {
  "directions" : icon_directions,
"beenhere" : icon_beenhere,
"directions_bike" : icon_directions_bike,
"add_location" : icon_add_location,
"directions_boat" : icon_directions_boat,
"directions_railway" : icon_directions_railway,
"directions_car" : icon_directions_car,
"directions_bus" : icon_directions_bus,
"directions_run" : icon_directions_run,
"directions_subway" : icon_directions_subway,
"edit_location" : icon_edit_location,
"directions_transit" : icon_directions_transit,
"directions_walk" : icon_directions_walk,
"ev_station" : icon_ev_station,
"hotel" : icon_hotel,
"flight" : icon_flight,
"layers" : icon_layers,
"local_bar" : icon_local_bar,
"local_activity" : icon_local_activity,
"layers_clear" : icon_layers_clear,
"local_atm" : icon_local_atm,
"local_cafe" : icon_local_cafe,
"local_airport" : icon_local_airport,
"local_convenience_store" : icon_local_convenience_store,
"local_dining" : icon_local_dining,
"local_drink" : icon_local_drink,
"local_car_wash" : icon_local_car_wash,
"local_gas_station" : icon_local_gas_station,
"local_florist" : icon_local_florist,
"local_grocery_store" : icon_local_grocery_store,
"local_hotel" : icon_local_hotel,
"local_hospital" : icon_local_hospital,
"local_laundry_service" : icon_local_laundry_service,
"local_movies" : icon_local_movies,
"local_library" : icon_local_library,
"local_mall" : icon_local_mall,
"local_offer" : icon_local_offer,
"local_parking" : icon_local_parking,
"local_play" : icon_local_play,
"local_phone" : icon_local_phone,
"local_pharmacy" : icon_local_pharmacy,
"local_pizza" : icon_local_pizza,
"local_post_office" : icon_local_post_office,
"local_printshop" : icon_local_printshop,
"local_see" : icon_local_see,
"local_taxi" : icon_local_taxi,
"my_location" : icon_my_location,
"local_shipping" : icon_local_shipping,
"map" : icon_map,
"navigation" : icon_navigation,
"near_me" : icon_near_me,
"place" : icon_place,
"person_pin_circle" : icon_person_pin_circle,
"person_pin" : icon_person_pin,
"pin_drop" : icon_pin_drop,
"restaurant" : icon_restaurant,
"rate_review" : icon_rate_review,
"satellite" : icon_satellite,
"store_mall_directory" : icon_store_mall_directory,
"terrain" : icon_terrain,
"streetview" : icon_streetview,
"subway" : icon_subway,
"traffic" : icon_traffic,
"tram" : icon_tram,
"transfer_within_a_station" : icon_transfer_within_a_station,
"train" : icon_train,
"zoom_out_map" : icon_zoom_out_map,
"restaurant_menu" : icon_restaurant_menu,
};
export { icons };
